import {
    GET_LIST,
    DETAIL,
    CREATE,
    UPDATE,
    DELETE,
    SEND
} from "../../api/mustering/mustering";
import querystring from "query-string";

const state = {
    list: [],
    detail: {},
    qr: "",
    pointing_users: [],
    status_user: {
        total_active: 0,
        total_away: 0,
        total_wfo: 0,
        total_wfh: 0,
    },
    columns: [
        {
            label: "Incident",
            field: "title",
        },
        {
            label: "Description",
            field: "description",
        },
        {
            label: "Impacted Area",
            field: "area",
        },
        {
            label: "Action",
            field: "action",
        },
    ],
};
const mutations = {
    SET_LIST: (state, payload) => {
        state.list = payload;
    },
    SET_DETAIL: (state, payload) => {
        payload["area"] = payload["area"];
        state.detail = payload;
    },
};
const actions = {
    GET_LIST: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_LIST(params);
        const data = resp.data.data;
        commit("SET_LIST", data);
    },
    DETAIL: async ({ commit }, args) => {
        const resp = await DETAIL(args.id);
        const data = resp.data.data;
        commit("SET_DETAIL", data);
    },
    CREATE: async ({ commit }, args) => {
        return await CREATE(args);
    },
    UPDATE: async ({ }, args) => {
        await UPDATE(args);
    },
    DELETE: async ({ commit }, args) => {
        await DELETE(args.id);
    },
    SEND: async ({ commit }, id) => {
        await SEND(id);
    },
};
const getters = {
    list: (state) => state.list,
    detail: (state) => state.detail,
    columns: (state) => state.columns,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
